module.exports = __webpack_public_path__ + "static/media/dislike.a73baa92.svg";